import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { AppContext } from "../../AppContext";

const FooterComp = () => {
  const [appContext, setAppContext] = useContext(AppContext);
  const buildVersion = "EmployeePortal - "+localStorage.getItem("VERSION");
  return (
    <footer className="footer-wrapper">
      <div className="footer section-content">
        {false && appContext.auth && (
          <>
            <div className="footer-section">
              <h3 className="footer-header">Quick Links</h3>
              <ul>
                <li>
                  <Link to="/">Pre-Trade Request</Link>
                </li>
                <li>
                  <Link to="/">OBA</Link>
                </li>
                <li>
                  <Link to="/">Gift & Entertainment</Link>
                </li>
                <li>
                  <Link to="/">Political Contribution & Donation</Link>
                </li>
                <li>
                  <Link to="/">Home</Link>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-header">Resource</h3>
              <ul>
                <li>
                  <Link to="/">Help Documentation</Link>
                </li>
                <li>
                  <Link to="/">How it works</Link>
                </li>
                <li>
                  <Link to="/">FAQs</Link>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h3 className="footer-header">Legals</h3>
              <ul>
                <li>
                  <Link to="/">Compliance</Link>
                </li>
                <li>
                  <Link to="/">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/">Privacy Policy</Link>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h3 className="footer-header">Contacts</h3>
              <div className="contact-item icon-call">
                <div className="contact-body">+12345678</div>
              </div>

              <div className="contact-item icon-address">
                <div className="contact-body">
                  <div>SS&C Tech.</div>
                  <div>188 - 106th Ave NE, Suite 400</div>
                  <div>Bellevue, WA 98004.</div>
                  <div>USA.</div>
                </div>
              </div>
            </div>
          </>
        )}
        <div title={buildVersion} className="footer-section footer-wide grid-center copyright">
          <p>
            © Copyright {new Date().getFullYear()} by SS&C Technologies, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterComp;
